var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useAuthApiClient } from "./AuthApiClientContext";
function createResponseHandler(clientFn) {
    var _this = this;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clientFn.apply(void 0, __spreadArray([], __read(args), false))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw response;
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
}
export function useLoginMutation() {
    var apiClient = useAuthApiClient();
    var queryClient = useQueryClient();
    return useMutation(createResponseHandler(apiClient.login), {
        onSuccess: function () {
            queryClient.resetQueries();
        },
    });
}
export function useLoginAsMutation() {
    var apiClient = useAuthApiClient();
    var queryClient = useQueryClient();
    return useMutation(createResponseHandler(apiClient.loginAs), {
        onSuccess: function () {
            queryClient.resetQueries();
        },
    });
}
/**
 * @deprecated Use useLoginMutation instead. There was a typo in the name so
 *   this is just an alias to not break existing code.
 */
export var useLoginAsMutiation = useLoginAsMutation;
export function useLogoutMutation() {
    var apiClient = useAuthApiClient();
    var queryClient = useQueryClient();
    return useMutation(createResponseHandler(apiClient.logout), {
        onSuccess: function () {
            queryClient.resetQueries();
        },
    });
}
export function useMeQuery() {
    var _this = this;
    var apiClient = useAuthApiClient();
    return useQuery(["auth", "me"], function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, apiClient.getMe()];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = { response: response };
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.me = (_b.sent()), _a)];
                case 3:
                    if (response.status === 401) {
                        return [2 /*return*/, { response: response, me: null }];
                    }
                    _b.label = 4;
                case 4: throw response;
            }
        });
    }); });
}
export function useMfaLoginMutation() {
    var apiClient = useAuthApiClient();
    var queryClient = useQueryClient();
    return useMutation(createResponseHandler(apiClient.mfaLogin), {
        onSuccess: function () {
            queryClient.resetQueries();
        },
    });
}
export function useRefreshTokenMutation() {
    var apiClient = useAuthApiClient();
    var queryClient = useQueryClient();
    return useMutation(createResponseHandler(apiClient.refreshToken), {
        onError: function () {
            queryClient.invalidateQueries("auth");
        },
    });
}
//# sourceMappingURL=authApiHooks.js.map